module.exports = __webpack_public_path__ + "static/img/hyyy_ct_a.ad29e3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/hyyy_ct_a.png
// module id = xgTA
// module chunks = 1